import styled from 'styled-components';

import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';

export const StyledContainer = styled(Container)<{ component?: React.ElementType }>`
  position: relative;
  z-index: 3;
`;

export const StyledPaper = styled(Paper)`
  background-image: none;
  background-color: rgba(0, 0, 0, 0.65);
  /* border: 1px solid rgba(255, 255, 255, 0.3); */
  backdrop-filter: blur(6px)
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  margin: 2rem -8px 0;
`;
